import { render } from "./MainNavigationBar.vue?vue&type=template&id=496ff95b&scoped=true"
import script from "./MainNavigationBar.vue?vue&type=script&lang=js"
export * from "./MainNavigationBar.vue?vue&type=script&lang=js"

import "./MainNavigationBar.vue?vue&type=style&index=0&id=496ff95b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496ff95b"]])

export default __exports__